import { useEffect, useRef } from 'react'
import { isProduction } from '../../modules/app/config'
import hotjar from './hotjar'

export const useHotjar = () => {
    const initialized = useRef(false)
    useEffect(() => {
        if (initialized.current) return
        if (isProduction()) hotjar()
        initialized.current = true
    }, [])
    return {
        initialize: () => hotjar(),
    }
}
